export const SET_USER_LIST = 'SET_USER_LIST';
export const SET_USER_PERMISSIONS_LIST = 'SET_USER_PERMISSIONS_LIST';
export const SET_USER_NEW_REMINDER = 'SET_USER_NEW_REMINDER';
export const SET_USER_WITH_NO_LOGIN_LIST = 'SET_USER_WITH_NO_LOGIN_LIST';
// export const SET_USER_MAP = "SET_USER_MAP";
// export const SET_CURRENT_USER = "SET_CURRENT_USER";
// export const USER_CD = "user_cd"
